import { render } from "./TaskFeedback.vue?vue&type=template&id=60cf386e"
import script from "./TaskFeedback.vue?vue&type=script&lang=js"
export * from "./TaskFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__